import { AppProviders, configureAppErrorReporting, TenantProvider } from "@how/app-kit";
import { RouterProvider } from "react-router";
import { env } from "../lib/env";
import { queryClient } from "../lib/query-client";
import { supabase } from "../lib/supabase";
import { bootStaffDashboard } from "./bootstrap";
import { createAppRouter } from "./router";

// This app's one error destination (ADR 0038), set before the first render so an early failure is reported too.
configureAppErrorReporting({
  surface: "staff_dashboard",
  supabaseUrl: env.VITE_SUPABASE_URL,
  client: supabase,
});

// An old address moves to the staff door (path, query and hash kept); the app does not start on the way out.
const boot = bootStaffDashboard(window.location, env);
if (boot.forward !== null) window.location.replace(boot.forward);
const router = boot.forward === null ? createAppRouter(boot.basename) : null;

/** Provider stack from @how/app-kit, the tenant resolved from the hostname, and this app's router. */
export function App() {
  if (router === null) return null;
  return (
    <AppProviders client={supabase} queryClient={queryClient}>
      <TenantProvider env={env} surface="staff_dashboard">
        <RouterProvider router={router} />
      </TenantProvider>
    </AppProviders>
  );
}
